import { useHttp } from './useHttp'

/* eslint-disable */

const Http = useHttp()

export const useGet = (url, params) =>
   Http.get(url, { params: params }).then((res) => res.data)
